import { api } from "@/api/client";
import type { LocationReverseResponse } from "@/api/types";
import { formatLocationSuggestion } from "@/lib/format-location-label";

const FALLBACK_NEAR_ME_LABEL = "Current location";

export async function resolveLocationLabel(
  lat: number,
  lng: number,
  signal?: AbortSignal,
): Promise<string> {
  const body = await api
    .get("locations/reverse", { searchParams: { lat, lng }, signal, retry: 0 })
    .json<LocationReverseResponse>();

  return body.suggestion ? formatLocationSuggestion(body.suggestion) : FALLBACK_NEAR_ME_LABEL;
}
